import React from 'react'
import PropTypes from 'prop-types'
import { Provider, inject, observer } from 'mobx-react'
import Store from './stores/Store.js'
import DateChooser from './components/DateChooser'
import PackageChooser from './components/PackageChooser'
import AvailabilityResult from './components/AvailabilityResult'
import './css/style.scss'
import './css/theme-compact.scss'
import './css/theme-normal.scss'


@inject("widgetStore")
@observer
export default class AvailabilityChecker extends React.Component {
  static propTypes = {
    widgetStore: PropTypes.object.isRequired,
    availableMessage: PropTypes.string.isRequired,
    unavailableMessage: PropTypes.string.isRequired,
    eventTypeId: PropTypes.number,
    eventTypeToken: PropTypes.string,
    packageGroupId: PropTypes.number,
    packageGroupToken: PropTypes.string,
    eventCategoryId: PropTypes.number,
    eventCategoryToken: PropTypes.string,
    theme: PropTypes.string,
    iframe: PropTypes.bool,
    showBookNowButton: PropTypes.bool,
    bookNowButtonText: PropTypes.string,
    showCustomBookingUrl: PropTypes.bool,
    customBookingUrl: PropTypes.string
  }
  
  static defaultProps = {
    showBookNowButton: true,
    theme: "compact",
    showCustomBookingUrl: false,
    customBookingUrl: ""
  }


  store = new Store({ widgetStore: this.props.widgetStore })

  componentDidMount() {
    const { eventTypeId, eventTypeToken, packageGroupId, packageGroupToken, eventCategoryId, eventCategoryToken } = this.props
    this.store.setup({ eventTypeId, eventTypeToken, packageGroupId, packageGroupToken, eventCategoryId, eventCategoryToken })
  }

  renderContent() {
    const { availableMessage, unavailableMessage, showBookNowButton, bookNowButtonText, showCustomBookingUrl, customBookingUrl } = this.props
    const { ready, loading, activeDate, activeEventType } = this.store

    if(!ready) {
      return null
    }
    else if(loading) {
      return (
        <div>Loading...</div>
      )
    }
    else if(!activeDate) {
      return (
        <DateChooser />
      )
    }
    else if(!activeEventType) {
      return (
        <PackageChooser />
      )
    }
    else {
      return (
        <AvailabilityResult
          availableMessage={availableMessage}
          unavailableMessage={unavailableMessage}
          bookNowButtonText={bookNowButtonText}
          showBookNowButton={showBookNowButton}
          showCustomBookingUrl={showCustomBookingUrl}
          customBookingUrl={customBookingUrl}
        />
      )
    }
  }

  render() {
    const { iframe, theme } = this.props
    const { store } = this

    return (
      <Provider store={store}>
        <div className={`wrapper theme-${theme} ${iframe ? "within-iframe" : ""}`}>
          { this.renderContent() }
        </div>
      </Provider>
    )
  }
}
